import { lazy } from 'react';
import { Outlet, RouteObject } from 'react-router-dom';
import routeConfig from 'app/config/routes';

const ProfilesPage = lazy(() => import('./components/ProfilesPage'));
const ProfileDetailPage = lazy(() => import('./components/ProfileDetailPage'));

const createProfilesRouter = (
  path: string,
  isGlobalContentManager: boolean,
): RouteObject => {
  const { detail } = routeConfig.settings.routes.profiles.routes;

  return {
    path,
    element: <Outlet />,
    children: [
      {
        index: true,
        element: (
          <ProfilesPage
            key={path}
            isGlobalContentManager={isGlobalContentManager}
          />
        ),
      },
      {
        path: detail.path,
        element: (
          <ProfileDetailPage
            key={path}
            isGlobalContentManager={isGlobalContentManager}
          />
        ),
      },
      {
        path: `${detail.path}/${detail.routes.tab.path}`,
        element: (
          <ProfileDetailPage
            key={path}
            isGlobalContentManager={isGlobalContentManager}
          />
        ),
      },
    ],
  };
};

export const profilesRouter = createProfilesRouter(
  routeConfig.settings.routes.profiles.path,
  false,
);

export const globalProfilesRouter = createProfilesRouter(
  routeConfig.settings.routes.globalProfiles.path,
  true,
);
